export default __webpack_public_path__ + "static/media/s3_bubble_left.3acd86b7.png";